import { render, staticRenderFns } from "./PromptPopups.vue?vue&type=template&id=0f108158&"
import script from "./PromptPopups.vue?vue&type=script&lang=js&"
export * from "./PromptPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports